module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [_c('navigation'), _vm._v(" "), _c('about-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67532ba6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/spa/About/About.vue
// module id = 273
// module chunks = 0